export * from '@primeuix/themes/lara/floatlabel';
export { default } from '@primeuix/themes/lara/floatlabel';
